import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import dayjs from 'dayjs';

const Calendar = () => {
  const [currentMonth, setCurrentMonth] = useState(dayjs());
  const navigate = useNavigate();

  const startDay = currentMonth.startOf('month').startOf('week');
  const endDay = currentMonth.endOf('month').endOf('week');

  const days = [];
  let day = startDay;

  while (day.isBefore(endDay, 'day')) {
    days.push(day);
    day = day.add(1, 'day');
  }

  const goToAddShift = (date) => {
    navigate(`/shifts/new?date=${date.format('YYYY-MM-DD')}`);
  };

  const isToday = (date) => date.isSame(dayjs(), 'day');
  const isCurrentMonth = (date) => date.month() === currentMonth.month();

  return (
    <div className="min-h-screen bg-[#0E0A1F] text-white p-6">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-2xl font-bold mb-6">Shift Calendar</h1>

        {/* Month Navigation */}
        <div className="flex justify-between items-center mb-4">
          <button onClick={() => setCurrentMonth(currentMonth.subtract(1, 'month'))}>← Prev</button>
          <h2 className="text-lg font-semibold">
            {currentMonth.format('MMMM YYYY')}
          </h2>
          <button onClick={() => setCurrentMonth(currentMonth.add(1, 'month'))}>Next →</button>
        </div>

        {/* Calendar Grid */}
        <div className="grid grid-cols-7 gap-2 text-center text-sm text-gray-400 mb-2">
          {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map((d) => (
            <div key={d}>{d}</div>
          ))}
        </div>

        <div className="grid grid-cols-7 gap-2">
          {days.map((date, idx) => (
            <div
              key={idx}
              onClick={() => goToAddShift(date)}
              className={`cursor-pointer p-2 rounded-lg text-center border hover:bg-purple-700 transition 
              ${isToday(date) ? 'bg-purple-600 text-white font-bold' : ''}
              ${!isCurrentMonth(date) ? 'opacity-40' : 'bg-[#1C1235] hover:bg-[#8F4EFF]'}
              `}
            >
              {date.date()}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Calendar;
